import { render, staticRenderFns } from "./VisitPositions.vue?vue&type=template&id=fb074b5e&"
import script from "./VisitPositions.vue?vue&type=script&lang=js&"
export * from "./VisitPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports